import HttpClient from './http-client';
import URL from './url';

export default class DictionaryApi {

    static getComprehensionKeywords(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_COMPREHENSION_KEYWORDS + "?" + params.join('&') : URL.GET_COMPREHENSION_KEYWORDS;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }


}